<template>
  <canvas id="ninja" @click="touch()" class="ninja" width="370" height="530"></canvas>
</template>

<script>
const STATES = Object.freeze({
  STATE_DEFAULT: 'default',
  STATE_SLEEPING: 'sleeping',
  STATE_FOCUS: 'focus',
  STATE_FAILURE: 'failure',
  STATE_SUCCESS: 'success',
  STATE_WAVE: 'wave',
  STATE_BLINK: 'blink',
  STATE_COFFEE: 'coffee',
  STATE_SPILL_LEFT: 'spill',
  STATE_SPILL_RIGHT: 'spill2',
  STATE_SIPPING: 'sipping',
  STATE_ANGRY: 'angry',
});

const spritesheet = new Image();
const spritesheetSmoke = new Image();
spritesheet.src = '/images/backend/ninja/ninja.png';
spritesheetSmoke.src = '/images/backend/ninja/smoke.png';

class NinjaState {
  key;
  image = 'default.png';

  constructor(key, image) {
    this.key = key;
    this.image = image;
  }
}

export default {
  name: "TNinja",
  props: {
    assets: {
      type: String,
      default: '/images/backend/ninja',
    },
    status: {
      type: String,
      default: 'default',
    }
  },
  watch: {
    status(current, previous) {
      this.currentState = current;
    }
  },
  data() {
    let currentState = STATES.STATE_DEFAULT;

    return {
      tileWidth: 370,
      tileHeight: 530,
      states: [
        new NinjaState(STATES.STATE_DEFAULT, 3),
        new NinjaState(STATES.STATE_SUCCESS, 10),
        new NinjaState(STATES.STATE_SLEEPING, 6),
        new NinjaState(STATES.STATE_FOCUS, 5),
        new NinjaState(STATES.STATE_FAILURE, 4),
        new NinjaState(STATES.STATE_BLINK, 1),
        new NinjaState(STATES.STATE_WAVE, 11),
        new NinjaState(STATES.STATE_COFFEE, 2),
        new NinjaState(STATES.STATE_SPILL_LEFT, 7),
        new NinjaState(STATES.STATE_SPILL_RIGHT, 9),
        new NinjaState(STATES.STATE_SIPPING, 8),
        new NinjaState(STATES.STATE_ANGRY, 0),
      ],
      currentState: currentState,
      temporaryState: null,
      temporaryTimeout: undefined,
      interval: undefined,
      intervalTick: undefined,
      frame: 0,
      emotions: {
        anger: 0,
      },
    }
  },
  mounted() {
    this.currentState = this.status;
    this.interval = setInterval(() => {
      if (this.emotions.anger > 0) {
        this.emotions.anger = Math.max(0, this.emotions.anger - 4);
      }
      if (!this.temporaryState && this.currentState === STATES.STATE_DEFAULT) {
        this.blink(50 + (Math.random() * 200));
      }
      if (!this.temporaryState && this.currentState === STATES.STATE_COFFEE) {
        this.sip(800 + (Math.random() * 500));
      }
      this.render();
    }, 4750);
    this.intervalTick = setInterval(() => {

      this.frame++;
      this.render();
    }, 300);
    this.wave();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.intervalTick);
  },
  computed: {
    image() {
      const path = this.assets;
      const file = this.state.image;

      return file;
    },
    activeState() {
      const activeState = this.temporaryState || this.currentState;
      if (this.emotions.anger > 6 && activeState === STATES.STATE_DEFAULT) {
        return STATES.STATE_ANGRY;
      }
      return activeState;
    },
    state() {
      const activeState = this.activeState;
      return this.states.find((state) => {
        return state.key === activeState;
      });
    }
  },
  methods: {
    render() {
      if (!spritesheet.complete) return;
      if (!spritesheetSmoke.complete) return;
      const element = document.getElementById('ninja');
      const context = element.getContext('2d');
      context.clearRect(0, 0, 370, 530);
      context.drawImage(spritesheet, 370 * this.image, 0, 370, 530, 0, 0, 370, 530);
      if (this.activeState === STATES.STATE_COFFEE) {
        context.drawImage(spritesheetSmoke, 38 * Math.floor(this.frame % 4), 0, 38, 82, 157, 225, 38, 82);
      }
    },
    success() {
      this.temporary(STATES.STATE_SUCCESS)
    },
    failure() {
      this.temporary(STATES.STATE_FAILURE);
    },
    wave() {
      this.temporary(STATES.STATE_WAVE, 800)
    },
    sip(timeout = 200) {
      this.temporary(STATES.STATE_SIPPING, timeout)
    },
    blink(timeout = 200) {
      this.temporary(STATES.STATE_BLINK, timeout)
    },
    temporary(temporaryState, timeout = 1000) {
      clearTimeout(this.temporaryTimeout);
      this.temporaryState = temporaryState;

      this.temporaryTimeout = setTimeout(() => {
        this.temporaryState = null;
      }, timeout);
      this.render();
    },
    touch() {
      this.emotions.anger++;
      if ([STATES.STATE_COFFEE, STATES.STATE_SIPPING].includes(this.currentState)) {
        this.temporary(this.activeState === STATES.STATE_SPILL_RIGHT ? STATES.STATE_SPILL_LEFT : STATES.STATE_SPILL_RIGHT, 600)
      } else {
        if (this.emotions.anger > 10) {
          this.failure();
          return;
        }
        this.blink();
      }
    }
  }
}
</script>

<style lang="scss">
.ninja-playground {
  position: relative;
  padding-right: 20%;
}

.ninja {
  position: absolute;
  bottom: -0.3rem;
  right: 5%;
  width: 12%;
  -webkit-user-drag: none;
  user-select: none;
  z-index: 999;
  background: #1F1F25;
  border-radius: 10px;
  padding: .5rem;
}
</style>